import * as v from "valibot"

export const CENTRA_MARKET_CODE = {
    Jp: "jp",
    Eu: "eu",
    Na: "na",
    Apac: "apac"
} as const

export type CentraMarketCode =
    (typeof CENTRA_MARKET_CODE)[keyof typeof CENTRA_MARKET_CODE]

export const MarketCodeSchema = v.picklist(
    Object.values(CENTRA_MARKET_CODE) as [CentraMarketCode, ...CentraMarketCode[]]
)

export const validateMarketCode = (code: string) => v.safeParse(MarketCodeSchema, code)
